<template>
  <nav class="body__sidebar" id="body__sidebar" aria-label="Menú de configuración">
    <div class="nav-mob-resp">
      <hidden-arrow></hidden-arrow>
      <div class="title">
        <div class="title__icon" aria-hidden="true">
          <i class="fa-solid fa-gear"></i>
        </div>
        <div class="title__text">
          <h2>Configuración</h2>
          <p>{{ role === 'admin' ? 'Ajustes de tu cuenta' : 'Ajustes de tu empresa' }}</p>
        </div>
      </div>
      <div class="tabs">
        <router-link :to="{ path: '/configuracion', query: { tab: 'perfil' } }" class="tab" :class="{ active: active === 'perfil' }">
          <div class="tab__icon" aria-hidden="true"><i class="far fa-user"></i></div>
          <div class="tab__text"><p>Perfil</p></div>
        </router-link>
        <router-link :to="{ path: '/configuracion', query: { tab: 'password' } }" class="tab" :class="{ active: active === 'password' }">
          <div class="tab__icon" aria-hidden="true"><i class="fas fa-lock"></i></div>
          <div class="tab__text"><p>Contraseña</p></div>
        </router-link>
        <router-link
          v-if="role === 'cliente'"
          :to="{ path: '/configuracion', query: { tab: 'empresa' } }"
          class="tab"
          :class="{ active: active === 'empresa' }"
        >
          <div class="tab__icon" aria-hidden="true"><i class="fas fa-building"></i></div>
          <div class="tab__text"><p>Empresa</p></div>
        </router-link>
        <router-link
          v-if="role === 'admin'"
          :to="{ path: '/configuracion', query: { tab: 'empresa-admin' } }"
          class="tab"
          :class="{ active: active === 'empresa-admin' }"
        >
          <div class="tab__icon" aria-hidden="true"><i class="fas fa-building"></i></div>
          <div class="tab__text"><p>Empresa</p></div>
        </router-link>
        <router-link
          v-if="role === 'admin'"
          :to="{ path: '/configuracion', query: { tab: 'entidades' } }"
          class="tab"
          :class="{ active: active === 'entidades' }"
        >
          <div class="tab__icon" aria-hidden="true"><i class="fas fa-sitemap"></i></div>
          <div class="tab__text"><p>Entidades</p></div>
        </router-link>
        <router-link
          v-if="role === 'cliente'"
          :to="{ path: '/configuracion', query: { tab: 'facturacion' } }"
          class="tab"
          :class="{ active: active === 'facturacion' }"
        >
          <div class="tab__icon" aria-hidden="true"><i class="fas fa-file-invoice"></i></div>
          <div class="tab__text"><p>Facturación</p></div>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import HiddenArrow from '@/components/HiddenArrow.vue'

export default {
  name: 'ConfiguracionSidebar',
  components: { HiddenArrow },
  props: {
    active: {
      type: String,
      default: 'perfil'
    }
  },
  data() {
    return {
      role: localStorage.getItem('role')
    }
  }
}
</script>
